import { render } from "./HeartIcon.vue?vue&type=template&id=ea0c0e82"
import script from "./HeartIcon.vue?vue&type=script&lang=ts"
export * from "./HeartIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script